import {StyleSheet} from 'react-native';
export default StyleSheet.create({
    iconFull: {
        width: 32,
        height: 32,
        borderRadius: 16,
        alignItems: 'center',
        justifyContent: 'center',
    },
    categoryButton:{
        alignItems:'center',
        width:'25%'
    },
    categoryText:{
        marginTop:5,
        fontFamily: 'Raleway',
        fontSize: 11,
        textAlign:'center'
    }
})